import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useMemo, useCallback } from 'react'
import moment from 'moment-timezone'
import petrovich from 'petrovich'
import { prop } from 'ramda'

import CafeteriaSubsidies from 'app/common/components/Cafeteria/CafeteriaSubsidies'
import SimpleDate from 'app/common/classes/simple-date'

import {
  cafeteriaSubsidiesPathMask,
  params as p,
  createPath,
  getSchoolTypeExact,
  getStudentIdExact,
  getDateExact,
  monthFormat,
  dateFormat,
  isMonthly,
} from 'app/pages/routePaths'

import selectPerson, { type Person } from '../selectPerson'
import useSchoolAsCamp from '../useSchoolAsCamp'

type Props = {
  params: {
    id: string
    date: string
    schoolType: string
  }
  router: {
    replace: (pathname: string) => void
    push: (pathname: string) => void
  }
}

const SubsidiesPage = ({ params, router: { push } }: Props) => {
  const { t } = useTranslation('cafeteria')

  const date = getDateExact(params)
  const id = getStudentIdExact(params)
  const schoolType = getSchoolTypeExact(params)

  const person: Person = useSelector((state) => selectPerson(state, id))

  const school = useSchoolAsCamp(id, schoolType)
  const school1 = useMemo(
    // TODO useSchoolAsCamp must return id: string
    () => ({ id: String(school.id), title: school.title, isCamp: school.isCamp }),
    [school],
  )

  const handleChangeDate = useCallback(
    (newDate: string, newDateFormat: string, daily: boolean = false) => {
      push(
        createPath(
          {
            [p.studentId]: id,
            [p.schoolType]: schoolType,
            [p.date]: moment(newDate, newDateFormat).format(daily ? dateFormat : monthFormat),
          },
          cafeteriaSubsidiesPathMask,
        ),
      )
    },
    [id, push, schoolType],
  )

  const dateType = isMonthly(date) ? 'month' : 'day'
  const simpleDate = new SimpleDate(date, isMonthly(date) ? monthFormat : dateFormat)

  const datePresentative =
    dateType === 'day'
      ? simpleDate.getStringFormatted('DD.MM.YYYY')
      : simpleDate.getStringFormatted('MMMM YYYY')

  const header = t('subsidies_header', {
    name: prop('first', petrovich(person.name, 'genitive')),
    date: datePresentative.toLocaleLowerCase(),
  })

  return (
    <CafeteriaSubsidies
      date={simpleDate}
      dateType={dateType}
      header={header}
      school={school1}
      person={person}
      onChangeDate={handleChangeDate}
    />
  )
}

export default SubsidiesPage
